<template>
    <component :is="props.tag" class="count-animation" ref="countRef" :style="`color:${props.color}`">
        <template v-if="gradient">
            <GradientText :text="formatter(state.displayNumber)"></GradientText>
        </template>
        <template v-else>
            {{ formatter(state.displayNumber) }}
        </template>
    </component>
</template>

<script setup>
import { defineProps, onMounted, reactive, ref } from "vue";
import { scrollController } from "../utils/scroll";

const props = defineProps({
    number: {
        type: [Number, String],
        default: 0,
    },
    unit: {
        type: String,
        default: ""
    },
    fixed: {
        type: Number,
        default: 0,
    },
    delay: {
        type: Number,
        default: 400,
    },
    currency: {
        type: Boolean,
        default: false,
    },
    gradient: {
        type: Boolean,
        default: false,
    },
    tag: {
        type: String,
        default: 'div'
    },
    color: {
        type: String,
        default: '#000000'
    }
});

const state = reactive({
    displayNumber: 0,
});

const countRef = ref(null);
const urlParams = new URLSearchParams(window.location.search)
const noEffect = !!urlParams.get("no_effect")

function formatter(value) {
    if (props.currency) {
        const num = (value / 100).toFixed(2)
        const currency = new Intl.NumberFormat().format(num)
        return `$${currency}`
    }
    const result = value.toLocaleString();
    if (props.unit) {
        const unit = props.unit
        if (props.unit === '%') {
            return `${result}${unit}`;
        }
        if(props.unit === 'x') {
            return `${unit}${result}`
        }

        return `${result} ${unit}`;
    }
    return result;
}

let interval;
let controller;
onMounted(() => {
    if (controller) {
        controller.destroy();
        controller = null;
    }
    // console.log("countRef.value", countRef.value)
    controller = scrollController(countRef.value, runAnimation);
});

function runAnimation() {
    if (state.displayNumber !== 0) {
        return
    }
    if (noEffect) {
        state.displayNumber = props.number
        return
    }
    setTimeout(() => {
        const changeTime = 10;

        let change = (props.number - state.displayNumber) / changeTime;
        // change = change >= 0 ? Math.ceil(change) : Math.floor(change);
        change = +change.toFixed(props.fixed);
        if (change === 0) {
            change = 1;
        }
        interval = setInterval(() => {
            if (state.displayNumber >= props.number) {
                state.displayNumber = props.number;
                clearInterval(interval);
                return;
            }
            state.displayNumber = state.displayNumber + change;
        }, 50);
    }, props.delay);
}
</script>

<style lang="scss" scoped>
.count-animation {
    white-space: nowrap;
}
</style>
